"use strict";

var _classCallCheck = require("/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/createClass.js");
var _assertThisInitialized = require("/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _inherits = require("/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _defineProperty = require("/home/keoadmin/agent/_work/119/s/node_modules/@babel/runtime/helpers/defineProperty.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
exports.Hour0To11Parser = void 0;
var _constants = require("../constants.js");
var _Parser = require("../Parser.js");
var _utils = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/function (_Parser$Parser) {
  _inherits(Hour0To11Parser, _Parser$Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case "K":
          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour11h, dateString);
        case "Ko":
          return match.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return (0, _utils.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getHours() >= 12;
      if (isPM && value < 12) {
        date.setHours(value + 12, 0, 0, 0);
      } else {
        date.setHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(_Parser.Parser);
exports.Hour0To11Parser = Hour0To11Parser;